import { useCurrentUserStore } from './useCurrentUserStore';

export default function loadCurrentUserRoleOnMount() {
  const currentUserStore = useCurrentUserStore();

  void currentUserStore.init();
}
